import PropTypes from "prop-types";
import { useState } from "react";

const UserPesoForm = ({ user = [], pesos, createPeso }) => {
  const [formData, setFormData] = useState({
    id_usuario: user.id_usuario, // Ensure it's always a string
    fecha: pesos.fecha || 0,
    peso: pesos.peso || 0, // Default to "efectivo"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createPeso(formData);
      alert("Pago registrado con éxito.");
    } catch (error) {
      console.error("Error registrando el pago:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Registro de Peso</h3>

      <div className="input-group">
        <label className="label">Fecha</label>
        <input
          type="date"
          name="fecha"
          value={formData.fecha}
          onChange={handleChange}
          className="input"
        />
      </div>
      <div className="input-group">
        <label className="label">Peso (kg)</label>
        <input
          type="text"
          name="peso"
          value={formData.peso}
          onChange={handleChange}
          className="input"
        />
      </div>
      <p></p>
      <button type="submit" className="button">
        Registrar Peso
      </button>
    </form>
  );
};

UserPesoForm.propTypes = {
  user: PropTypes.object.isRequired, // Expecting an array of user objects
  pesos: PropTypes.array.isRequired,
  createPago: PropTypes.func,
};

export default UserPesoForm;
